import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	exportIssuesFlagProgressTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exportIssuesFlagProgressDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exportIssuesFlagProgressAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	exportIssuesFlagProgressTitle: {
		id: 'issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-task-progress-flag.export-issues-flag-progress-title',
		defaultMessage: '{exportItemLabel} in progress',
		description:
			'Title of export issues flag, where {exportItemLabel} is the label of the selected option (like "CSV export (all fields)")',
	},
	exportIssuesFlagProgressDescription: {
		id: 'issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-task-progress-flag.export-issues-flag-progress-description',
		defaultMessage:
			'Stay on this page until the export is complete. Leaving will cancel the export.',
		description:
			'Description shown on top of the progress bar while exporting issues job is running',
	},
	exportIssuesFlagProgressAriaLabel: {
		id: 'issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-task-progress-flag.export-issues-flag-progress-aria-label',
		defaultMessage: 'Export {progress}% completed',
		description: 'Aria label for the export progress bar',
	},
});

export default messages;
